import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  buttonSearch: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
